import { Component, inject, OnInit } from '@angular/core';
import { OrderConfirmationComponent } from 'gung-standard';
import { interval } from 'rxjs';
import { startWith, switchMap, first } from 'rxjs';
import { CultSimplifiedOrderContextStatus, CultOrderContextService } from '../../services/cult-order-context.service';
import { CultUnifaunReturnsService, ShipmentPrints } from '../../services/cult-unifaun-returns.service';

@Component({
  selector: 'cult-cult-order-confirmation',
  templateUrl: './cult-order-confirmation.component.html',
  styleUrls: ['./cult-order-confirmation.component.scss'],
  standalone: false
})
export class CultOrderConfirmationComponent extends OrderConfirmationComponent implements OnInit {
  protected orderContextService = inject(CultOrderContextService);
  protected cultUnifaunReturnsService = inject(CultUnifaunReturnsService);

  cultContext?: CultSimplifiedOrderContextStatus;

  ngOnInit() {
    const contextId = this.router.snapshot.params.contextId;

    this.timeInterval = interval(1000)
      .pipe(
        startWith(0),
        switchMap(() => this.orderContextService.getSimplifiedOrderContext(contextId)),
        first(e => e.finalized)
      )
      .subscribe(
        context => {
          this.processing = false;
          this.cultContext = context;

          console.log('context', context);
        },
        err => {
          console.log('err', err);
        }
      );
  }

  openShipmentPdfNewWindow(shipmentPrint: ShipmentPrints) {
    this.cultUnifaunReturnsService.openShipmentPdfNewWindow(shipmentPrint);
  }
}
